import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';
import { Stack, StackItem } from '@optimus-web/core';
import { MatrixMapping } from '@mews/b2b-ui';
import { createPagedEntityTableConnect } from '../../entityManagement';
import EntityTable from '../../entityManagement/components/EntityTable';
import { getSelectedAddressesByIds } from '../selectors';
import { AddressSource } from '../types';
import { AddressEditLink } from '../components';
import AddressCountry from './AddressCountry';

const mapping: Array<MatrixMapping<AddressSource>> = [
    {
        valueKey: 'address',
        title: <LocalizedText textKey={TextKey.Address} />,
        render: ({ addressLine1, addressLine2, id, isPrimary }, { onEdit }) => (
            <AddressEditLink
                onEdit={onEdit}
                addressLine1={addressLine1}
                addressLine2={addressLine2}
                id={id}
                isPrimary={isPrimary}
            />
        ),
        columnWidth: '50%',
    },
    {
        valueKey: 'cityDetail',
        title: <LocalizedText textKey={TextKey.City} />,
        render: ({ postalCode, city }) => (
            <Stack vertical>
                <StackItem>{postalCode}</StackItem>
                <StackItem>{city}</StackItem>
            </Stack>
        ),
        columnWidth: '25%',
    },
    {
        valueKey: 'country',
        title: <LocalizedText textKey={TextKey.Country} />,
        render: ({ countryCode, countrySubdivisionCode }) => (
            <AddressCountry countryCode={countryCode} countrySubdivisionCode={countrySubdivisionCode} />
        ),
        columnWidth: '25%',
    },
];

const AddressesTable = EntityTable({ mapping });

// @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 1.
export default createPagedEntityTableConnect(getSelectedAddressesByIds)(AddressesTable);
